// @flow
import * as React from 'react'

export type PropsType = {
  size?: number,
  color?: string
}

export const AppleIcon = (props: PropsType): React.Node => {
  return (
    <svg
      height={props.size || 16}
      width={props.size || 16}
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.4933 15.5861C18.1909 16.2848 17.8329 16.928 17.4181 17.5193C16.8526 18.3255 16.3897 18.8835 16.0329 19.1934C15.4798 19.702 14.8873 19.9625 14.2527 19.9773C13.7972 19.9773 13.2478 19.8477 12.6083 19.5847C11.9667 19.323 11.3771 19.1934 10.838 19.1934C10.2726 19.1934 9.66619 19.323 9.01757 19.5847C8.36795 19.8477 7.84464 19.9847 7.44453 19.9983C6.83603 20.0242 6.2295 19.7563 5.62409 19.1934C5.23768 18.8563 4.75436 18.2786 4.17537 17.4601C3.55415 16.586 3.04343 15.5725 2.64331 14.417C2.21481 13.1689 2 11.9603 2 10.7902C2 9.44984 2.28962 8.29383 2.86973 7.32509C3.32564 6.54696 3.93216 5.93316 4.69128 5.48255C5.45039 5.03195 6.27061 4.80233 7.15392 4.78763C7.63724 4.78763 8.27104 4.93714 9.05867 5.23096C9.84408 5.52576 10.3484 5.67526 10.5695 5.67526C10.7348 5.67526 11.295 5.50045 12.2448 5.15195C13.1429 4.82874 13.9009 4.69492 14.5218 4.74764C16.2045 4.88343 17.4687 5.54675 18.3094 6.74177C16.8045 7.6536 16.0601 8.93072 16.0749 10.5691C16.0885 11.8452 16.5514 12.9071 17.4613 13.7503C17.8736 14.1417 18.3341 14.4441 18.8464 14.6589C18.7353 14.9812 18.618 15.2898 18.4933 15.5861ZM14.6342 0.400114C14.6342 1.40034 14.2688 2.33425 13.5404 3.19867C12.6614 4.22629 11.5982 4.8201 10.4453 4.7264C10.4306 4.60641 10.4221 4.48011 10.4221 4.3474C10.4221 3.38718 10.8401 2.35956 11.5824 1.51934C11.953 1.09392 12.4244 0.74019 12.996 0.458013C13.5663 0.180046 14.1058 0.0263242 14.6132 0C14.628 0.133715 14.6342 0.267438 14.6342 0.400101V0.400114Z'
        fill={props.color || 'black'}
      />
    </svg>
  )
}
